export default "__VITE_ASSET__ridc1e9o__"